/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  /** Unidade da simulação aberta na tela, que recebe a proposta copiada. */
  idUnidade?: string | null;
  /** Lead-corretor em atendimento, o mesmo da simulação aberta. */
  idLeadCorretor?: string | null;
}

/**
 * Lê o id da oportunidade criada pela cópia.
 *
 * O POST devolve o mesmo corpo da simulação, com o id em `data.idOportunidade`.
 */
export function extrairIdOportunidade(resposta: any): string | null {
  const id = resposta?.data?.idOportunidade;
  return typeof id === "string" && id ? id : null;
}

/** Proposta de origem escolhida no modal de cópia. */
interface Payload {
  /** Unidade escolhida no modal (a mesma da listagem de propostas). */
  idUnidadePropostaSelecionada: string;
  /** Campo propostaId do item escolhido na listagem de propostas. */
  idPropostaSelecionada: string;
}

/**
 * Copia uma proposta de origem para a simulação em andamento.
 *
 * Só pode ser chamada durante a criação da proposta, nunca depois de salva. A
 * cópia já volta criada como oportunidade em Simulação / Montando simulação,
 * com o mesmo contrato da consulta de oportunidade.
 */
export function useCopiarProposta(props: Props) {
  const postData = async (payload: Payload) => {
    const COPIAR_PROPOSTA = `${backofficeEnviroment}/common/oportunidades-lead/copia-proposta/v1`;
    const { data } = await instance.post(COPIAR_PROPOSTA, {
      idLeadCorretor: props.idLeadCorretor,
      idUnidade: props.idUnidade,
      ...payload,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Proposta copiada com sucesso!");
    },
    // Avisos de negócio do backend (ex.: nenhuma simulação encontrada) são
    // exibidos em toast com a mensagem exatamente como o POST retorna.
    onError: (error: any) => {
      const mensagens: string[] = (error?.response?.data?.notifications || [])
        .map((item: any) => item?.message)
        .filter(Boolean);

      if (mensagens.length === 0) {
        toast.error("Erro ao copiar proposta.");
        return;
      }

      mensagens.forEach((mensagem) => toast.warning(mensagem));
    },
  });

  return mutation;
}
